import { EInvoiceValidatorComponentModule } from './app/pages/modal-screens/e-invoice-validator/e-invoice-validate.module';
import { CommonClubOperationsModule } from './app/pages/modal-screens/common-club-operations/common-club-operations.module';
import { CommonConfirmationModalModule } from './app/pages/modal-screens/common-confirmation/common-confirmation.module';
import { CommonPullupMenuModule } from './app/pages/modal-screens/common-pullup-menu/common-pullup-menu.module';

import { MultiSelectModule } from 'primeng/multiselect';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/**
 * Created by ashok on 22/11/16.
 */
export const APP_MODULE = [
  CommonConfirmationModalModule,
  CommonPullupMenuModule,
  MultiSelectModule,
  BrowserModule,
  BrowserAnimationsModule,
  CommonClubOperationsModule,
  EInvoiceValidatorComponentModule,
];
